module.exports = __webpack_public_path__ + "img/interview-640_white.5560679b.png";